module.exports = __webpack_public_path__ + "static/media/bucket_fill.097c8463.svg";


//////////////////
// WEBPACK FOOTER
// ./src/game/bomber/bucket/bucket_fill.svg
// module id = 33
// module chunks = 0